import React, { useState } from 'react';
import Card from 'components/Card'
import SearchBar from 'components/SearchBar'
import { useLazyQuery } from '@apollo/client';
import { GET_REPORTS_BY_FILTER } from 'graphql/service';
import { debouncedErrorMessage } from 'utils/messageUtil';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { ParkingTableContainer } from './style';

const ParkingTable = () => {

  const [checkInDate, setCheckInDate] = useState(moment().tz(TIME_ZONE));
  const [checkOutDate, setCheckOutDate] = useState(moment().tz(TIME_ZONE).add(1, 'days'));
  const [dataType, setDataType] = useState("-select")
  const [reports, setReports] = useState([])

  // const [getReportsByFilter, { data: reportsData, loading }] = useLazyQuery(GET_REPORTS_BY_FILTER, {
  //   variables: { 
  //     checkInDate,
  //     checkOutDate,
  //     dataType,
  //   },
  //   fetchPolicy: 'cache-and-network',
  //   notifyOnNetworkStatusChange: true,
  //   onCompleted: (reportsData) => {
  //     if(reportsData.reports) {
  //       setReports(reportsData.reports)
  //     }
  //   },
  //   onError: (error) => {
  //     if (!error.networkError) {
  //       let content = error.message
  //       if(error.message.includes('Validation')) {
  //           content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
  //       }
  //       debouncedErrorMessage(content)
  //     }
  //   }
  // })

  const parkingArray = reports.map((report, index) => {
    return (
      <tr key={index}>
        <td>5/24/2020 5:34 PM</td>
        <td>Firstname Lastname Verylongname Maybe</td>
        <td>1234.56</td>
        <td>34.45</td>
        <td>1234.56</td>
      </tr>
    )
  })
  

  return (
    <Card>
      <SearchBar />
      <ParkingTableContainer>
        <thead>
          <tr>
            <th className="name">NAME</th>
            <th className="plate-number">PLATE NUMBER</th>
            <th className="type">TYPE</th>
            <th className="suite-number">SUITE #</th>
            <th className="status">STATUS</th>
            <th className="created">CREATED</th>
            <th className="action">ACTION</th>
          </tr>
        </thead>
        <tbody>
          {parkingArray}
        </tbody>
      </ParkingTableContainer>
    </Card>
  );
};

export default ParkingTable;
